import {Directive, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MetaMapVerificationEvent} from '../model/kamonal-model';

@Directive({
	selector: '[appMetaMapVerification]'
})
export class MetaMapVerificationDirective implements OnInit {
	@Output() emitVerificationStatus = new EventEmitter();
	@Input() appMetaMapVerification: any;

	constructor(
		private elRef: ElementRef) {

	}

	ngOnInit() {
		// this.elRef.nativeElement.setAttribute('metadata', this.appMetaMapVerification);
		this.elRef.nativeElement.addEventListener('metamap:loaded', (event) => {
			this.onLoaded(event, this.emitVerificationStatus);
		});
		this.elRef.nativeElement.addEventListener('metamap:userStartedSdk', (event) => {
			this.onStarted(event, this.emitVerificationStatus);
		});
		this.elRef.nativeElement.addEventListener('metamap:userFinishedSdk', (event) => {
			this.onFinished(event, this.emitVerificationStatus);
		});
		this.elRef.nativeElement.addEventListener('metamap:exitedSdk', (event) => {
			this.onExited(event, this.emitVerificationStatus);
		});
	}


	onLoaded(event, emitter) {
		emitter?.emit(MetaMapVerificationEvent.loaded);
	}

	onStarted(event, emitter) {
		emitter?.emit(MetaMapVerificationEvent.userStartedSdk);
	}

	onFinished(event, emitter) {
		emitter?.emit(MetaMapVerificationEvent.userFinishedSdk);
	}

	onExited(event, emitter) {
		emitter?.emit(MetaMapVerificationEvent.exitedSdk);
	}

}
